<template>
  <section class="stores-cta">
    <GridContainer padding>
      <Card
        v-bind="card"
        class="stores-cta__card"
      >
        <Paragraph class="stores-cta__text">
          Registrier dich fürs Cashback und richte die Handyrechnung in unter zwei Minuten in deinem
          Store ein. Für deinen ersten Kauf gibt es bis zu 10&nbsp;€ zurück.
        </Paragraph>
      </Card>
    </GridContainer>
  </section>
</template>

<script setup lang="ts">
import {
  GridContainer,
  Card,
  Paragraph,
  type CardComponentProps,
} from '@i22team/td-longtail-vue-components';

const card: CardComponentProps = {
  imagePosition: 'right',
  contentCenter: true,
  image: {
    src: '/content/content-images/dcb/stores/4d6aa2cbb7bbe96eca15ea2d9a9cdbf9/cta.jpg',
    aspectRatio: '1 / 1',
    sizes: 'xs:100vw sm:50vw lg:480px',
    alt: 'Person nutzt eine Store-App auf dem Smartphone',
  },
  label: {
    customClass: 'text--primary text--uppercase',
    text: 'Jetzt loslegen',
    mb: true,
  },
  heading: {
    tag: 'h3',
    size: 'lg',
    text: 'Erster In-App-Kauf? 100 % zurück.',
    spacesBottomRem: true,
  },
  buttons: [
    {
      tag: 'button',
      type: 'button',
      variant: 'primary',
      label: 'Cashback sichern',
      size: 'medium',
      onClick: () => {
        console.log(document.getElementById('mail-form'));
        document
          .getElementById('mail-form')
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
    },
    {
      tag: 'button',
      type: 'button',
      variant: 'outline-primary',
      label: "So richtest du's ein",
      size: 'medium',
      onClick: () => {
        document.getElementById('wofuer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
    },
  ],
};
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.stores-cta {
  background: var(--color-gray-100);
  padding-block: 3rem;

  @include mq($mq-md) {
    padding-block: 4rem;
  }

  &__card {
    --card-bg-color: #fff;
    --card-image-container-height: 90vw;
    --card-action-wrap: wrap;
    --card-action-wrap-sm: wrap;
    --card-action-justify: center;
    max-width: 1280px;
    margin-inline: auto;

    @include mq($mq-md) {
      --card-image-container-md-height: 523px;
      --card-image-container-width: 523px;
    }

    :deep(.card__image) {
      align-self: center;

      .card__image-container {
        height: auto;
        @include mq($mq-lg) {
          height: 100%;
        }
      }

      img {
        border-radius: 25px;
        overflow: hidden;
        height: auto;
        @include mq($mq-lg) {
          height: 100%;
        }
      }
    }
  }

  &__eyebrow {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    color: #c20063;
    margin-bottom: 12px;
  }

  &__text {
    margin-bottom: 1.5rem;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
